<template>
  <div class="pt-page pt-page-1 pt-page-current show-overflow" >
    <router-link class="top-nav" to="/"><i class="fa fa-arrow-down"></i></router-link>
    <router-link class="logo" to="/">OM</router-link>
    <div class="portfolio-container godown">
      <div class="container">
        <div class="heading-container">
          <h1>Portfolio</h1>
        </div>
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="portfolio-links">
              <li>
                <h2><a href="https://zverg.com" target="_blank">Zverg</a></h2>
                <h3>Laravel, Angular.js, Node.js, Socket.io, Twitter Bootstrap</h3>
                <router-link class="cool-button" to="/portfolio/zverg">View Case Study</router-link>
              </li>
              <li>
                <h2>Reviews</h2>
                <h3>From Freelance Clients on Upwork</h3>
                <router-link class="cool-button" to="/portfolio/upwork">Read Reviews</router-link>
              </li>
              <li>
                <h2><a href="https://profiles.wordpress.org/omurphy/#content-plugins"
                    target="_blank">Wordpress Plugins</a></h2>
                <h3>Wordpress, PHP, Javascript</h3>
                <a class="cool-button" href="https://profiles.wordpress.org/omurphy/#content-plugins"
                  target="_blank">View Plugins</a>
              </li>
              <li>
                <h2><a href="http://cravely.com/" target="_blank">Cravely Admin Dashboard</a></h2>
                <h3>Laravel, Jquery</h3>
                <router-link class="cool-button" to="/portfolio/cravely">View Case Study</router-link>
              </li>
              <li>
                <h2><a href="https://tomiki.org/" target="_blank">Tomiki Aikido</a></h2>
                <h3>Converted Legacy PHP Membership site to Wordpress</h3>
                <a class="cool-button" href="https://tomiki.org/" target="_blank">Visit Website</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/scss/portfolio.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;

export default {
  name: "Portfolio",
  mounted: function() {
    const $page = $(".pt-page");
    if ( $page.hasClass('show-overflow') ) {
      $page.find(".godown").addClass("animated fadeInDown");
    }
  }
};
</script>
